module.exports = __webpack_public_path__ + "static/media/np_invoices_2064117_B03060.cc80a3ec.svg";